export enum ModalId {
  Geolocation,
  PackageDetails,
  PriceBreakdown,
  ViewVehicles
}

export const ModalPriorities = {};
